import {Session} from '../Session';

export class Factory {

    // ########################################

    public create(): Session {
        const sessionStorage: Storage = window.sessionStorage;

        return new Session(
            sessionStorage
        );
    }

    // ########################################
}
